<template>
  <div class="page-main">
    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <!-- <label style="font-size: large;font-weight: bold;">Buat Picklist (Skema Auto)</label> -->
        <h3>Buat Picklist (Skema Auto)</h3>
        <label>Silahkan pilih jenis DO, jumlah Tray atau kategori barang yang akan di proses</label>
      </div>
      <div class="col-sm-4">
        <h4>Step 1 / 2</h4>
      </div>
      <hr/>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <h4>1. Jenis Pesanan (pilih salah satu)</h4>
        <b-form-group>
          <b-form-radio-group
              tabindex="1"
              ref="typeOrder"
              size="lg"
              autofocus="autofocus"
              id="radio-group-1"
              v-model="selectedOrder"
              :options="optionsOrder"
              name="type-order"
              buttons
              button-variant="outline-primary"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <h4>2. Jumlah Tray / Container (pilih salah satu)</h4>
        <b-form-group>
          <b-form-radio-group
              tabindex="2"
              size="lg"
              id="radio-group-2"
              v-model="selectedTray"
              :options="optionsTray"
              name="type-tray"
              buttons
              button-variant="outline-primary"
          ></b-form-radio-group>
        </b-form-group>
        <input type="text" v-if="selectedTray === 0" name="type-tray-other" id="id-type-tray-others" />
      </div>
    </div>
    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <h4>3. Pengecualian</h4>
        <b-form-group>
          <b-form-radio-group
              tabindex="3"
              size="lg"
              id="radio-group-3"
              v-model="selectedException"
              :options="optionsException"
              name="type-order"
              buttons
              button-variant="outline-primary"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </div>

    <div class="row mt-3 mb-3">
      <div class="col-sm-8 fa-pull-right mr-0">
        <b-button tabindex="4" variant="success" class="mr-3" v-on:click="goToAutoTwo">Selanjutnya</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      content: '',
      selectedOrder: 'multi',
      optionsOrder: [
        { text: 'Single Line', value: 'single' },
        { text: 'Multi Line', value: 'multi' },
      ],
      selectedTray: 12,
      optionsTray: [
        { text: '2 Tray', value: 2 },
        { text: '4 Tray', value: 4 },
        { text: '6 Tray', value: 6 },
        { text: '8 Tray', value: 8 },
        { text: '10 Tray', value: 10 },
        { text: '12 Tray', value: 12 },
        { text: 'Lain-nya', value: 0 },
      ],
      selectedException: 'NOTHING',
      optionsException: [
        { text: 'Tidak Ada', value: 'NOTHING' },
        { text: 'Tidak Ada Expiry Date', value: 'NO_EXPIRY_DATE' },
        { text: 'Tidak Ada Batch', value: 'NO_BATCH' },
      ]
    };
  },
  methods: {
    goToAutoTwo: function() {
      this.$router.push('/do/config/auto/2')
    },
  },
  mounted() {
    //this.$refs.typeOrder.$el.focus();
  }
};
</script>
